declare var STATIC_BASE_URL:string;

import '../styles/forbes.scss';

import { h, Component } from 'preact';

export default class Forbesresearch extends Component<any, any> {

    constructor() {
        super();
    }

    public render (props, state): any {
      
        return <div id="forbes">
            <div class="mainWrp">
                <section class="center">
                    <div class="logoWrp" style="margin: 0 0 2rem 0">
                        <img alt="Forbes Insights" class="logo" src={ STATIC_BASE_URL + 'images/public/forbes-insight_big@2x.png' } />
                        <div>AI solutions powered by Querlo</div>
                    </div>
                    <iframe src="//www.querlo.com/chat/ForbesResearch" frameBorder="0" width="100%" height="500"></iframe>
                </section>
            </div>
        </div>
      
    }
}


// WEBPACK FOOTER //
// ./ts/Forbesresearch.tsx